






























































































































// vue
import { computed, defineComponent, ref, watch } from '@vue/composition-api';

// components
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

// configs
import geoRecordFilter from '@/vue3/configs/geoRecordFilter';

// primevue
import Button from 'primevue/button';
import InputText from 'primevue/inputtext/InputText';
import { useService } from '../api/services';
import GeoRecordSavedFilter from '@/vue3/components/GeoRecordSavedFilter.vue';
import { useNotify } from '../hooks/notifyHook';
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
    components: {
        EditorDropdown,
        Button,
        InputText,
        GeoRecordSavedFilter,
        ProgressSpinner,
    },
    props: {
        accounts: {
            type: Array,
            default: () => [],
        },
        filterData: {
            type: Array,
            default: () => {},
        },
        geoRecords: {
            type: Array,
            default: () => [],
        },
        mapbox: {
            type: Object,
            default: null,
        },
        layerTree: {
            type: Object,
            default: null,
        },
        updatefilterData: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        //hooks
        const { createGeoRecordFilter } = useService();
        const { successToast, errorToast } = useNotify();

        // reactive
        const filterSelector = ref();
        const filter = ref({});
        const filters = ref<any[]>([]);
        const filterName = ref('');
        const toolValue = ref('addfilter');
        const showsavedFilter = ref(false);
        const isLoading = ref(false);
        const showAddFilter = ref(true);
        const operatorOption = ref([
            { id: '==', name: 'equal (=)' },
            { id: '!==', name: 'does not equal (!=)' },
        ]);
        const operatorSelector = ref();

        // refs
        const allGeoRecordLayers = ref();

        let geoRecordFilterNew = geoRecordFilter;
        //services
        const { getTags } = useService();

        // watchers
        watch(filterSelector, async () => {
            if (filterSelector.value.name == 'Tags') {
                const filterDataTags = await getTags();
                await props.updatefilterData({tags: filterDataTags});
            }
        });

        const filterOption = [
            {
                name: 'Add Filter',
                id: 'addfilter',
                icon: 'fas fa-filter',
            },
            {
                name: 'Saved Filter',
                id: 'savedfilter',
                icon: 'fas fa-bookmark',
            },
        ];

        // computed
        const filterDataComputed = computed(() => {
            if (filterSelector.value.options) {
                return props.filterData[filterSelector.value.options.dataKey];
            }
            return null;
        });

        // methods
        const generateFilterExpression = (expression: any) => {
            allGeoRecordLayers.value =
                props.mapbox.map.getSource('geo-records')._data.features;
            let operator = '';
            if (expression.operator === 'contains') {
                operator = 'in';
            } else if (expression.operator === 'equals') {
                operator = '==';
            } else {
                operator = expression.operator;
            }
            if (expression.operator === undefined) {
                operator = 'in';
            }
            let exp: any[] = [];

            if (operator === 'in' && !Array.isArray(expression.value)) {
                exp = [
                    operator,
                    expression.value,
                    ['get', expression.optionLabel],
                ];
            } else {
                exp = [
                    operator,
                    ['get', expression.optionLabel],
                    Array.isArray(expression.value)
                        ? ['literal', expression.value]
                        : expression.value,
                ];
            }

            allGeoRecordLayers.value.forEach((element) => {
                switch (expression.optionLabel) {
                    case 'accountId': {
                        if (operatorSelector.value.id === '==') {
                            if (element.properties.accountId !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (element.properties.accountId == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'projectId': {
                        if (operatorSelector.value.id === '==') {
                            if (
                                !exp[2][1].includes(
                                    element.properties.projectId,
                                )
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (
                                exp[2][1].includes(element.properties.projectId)
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'isTask': {
                        if (operatorSelector.value.id === '==') {
                            if (element.properties.isTask !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (element.properties.isTask == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'statusId': {
                        if (operatorSelector.value.id === '==') {
                            if (element.properties.statusId !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (element.properties.statusId == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'assigneeAccountId': {
                        if (operatorSelector.value.id === '==') {
                            if (
                                element.properties.assigneeAccountId !== exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (
                                element.properties.assigneeAccountId == exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'geoRecordCategoryId': {
                        if (operatorSelector.value.id === '==') {
                            if (
                                element.properties.geoRecordCategoryId !==
                                exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (
                                element.properties.geoRecordCategoryId == exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'title': {
                        if (operatorSelector.value.id === '==') {
                            if (
                                element.properties.title === '' &&
                                !element.properties.title
                                    .toLowerCase()
                                    .includes(exp[2].toLowerCase())
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (
                                element.properties.title !== '' &&
                                element.properties.title
                                    .toLowerCase()
                                    .includes(exp[2].toLowerCase())
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'geoRecordTagId': {
                        if (operatorSelector.value.id === '==') {
                            if (!element.properties.tagIds) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            if (
                                element.properties.tagIds &&
                                !element.properties.tagIds.includes(exp[2])
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (operatorSelector.value.id === '!==') {
                            if (
                                element.properties.tagIds &&
                                element.properties.tagIds.includes(exp[2])
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    default:
                        break;
                }
            });

            return exp;
        };

        const addFilter = () => {
            filter.value['name'] = filterSelector.value.name;
            geoRecordFilterNew = geoRecordFilterNew.filter((x: any) => {
                if (x.name !== filterSelector.value.name) {
                    return x;
                }
            });

            filter.value['optionLabel'] = filterSelector.value.id;
            filter.value['isOperator'] =
                filterSelector.value.options.isOperator;
            if (operatorSelector.value) {
                filter.value['operator'] =
                    operatorSelector.value.name != undefined
                        ? operatorSelector.value.name
                        : '==';
            }
            filters.value.push(filter.value);
            filter.value['expression'] = generateFilterExpression(filter.value);
            filterSelector.value = null;
            operatorSelector.value = null;

            cancel();
        };

        const removeFilter = (key: any) => {
            allGeoRecordLayers.value.forEach((element) => {
                props.layerTree.geoRecordNodeSelect(element, true);
            });
            filters.value.splice(key, 1);
            allGeoRecordLayers.value = [];
            filters.value = [];
        };

        const saveFilter = async () => {
            let fd = new FormData();
            var formVal: any = {};
            var filterArr: any = [];

            filters.value.forEach((filter) => {
                let operator = '';

                if (filter.operator === 'contains') {
                    operator = 'in';
                } else if (filter.operator === 'equals') {
                    operator = '==';
                } else {
                    operator = filter.operator;
                }
                if (filter.operator === undefined) {
                    operator = 'in';
                }

                var filterObj: any = {};

                filterObj.filterField = filter.optionLabel;
                filterObj.filterValue = '' + filter.value;
                filterObj.filterCondition = operator;
                filterObj.filterDisplayValue = '' + filter.displayValue;
                filterObj.filterOperatorValue = '' + filter.operator;

                filterArr.push(filterObj);
            });

            formVal.name = filterName.value;
            formVal.filter = filterArr;
            fd.append('json', JSON.stringify(formVal));
            isLoading.value = true;

            try {
                await createGeoRecordFilter(fd);

                successToast('Geo Record Filter has been saved');
            } catch (e) {
                console.log(e);
            } finally {
                isLoading.value = false;
                filterName.value = '';
            }
        };

        const cancel = () => {
            filterSelector.value = null;
            filter.value = {};
        };

        const filterClick = (tool: any) => {
            showsavedFilter.value = tool.id == 'savedfilter';
            showAddFilter.value = tool.id == 'addfilter';
            toolValue.value = tool.id;
        };

        return {
            geoRecordFilterNew,
            filterSelector,
            filter,
            filters,
            filterDataComputed,
            cancel,
            addFilter,
            removeFilter,
            saveFilter,
            filterName,
            filterOption,
            showAddFilter,
            showsavedFilter,
            filterClick,
            toolValue,
            isLoading,
            operatorOption,
            operatorSelector,
        };
    },
});
